import { StateProvinces } from '@bb/domain/dist/types';
import { invert, mapValues, method } from 'lodash';

const UppercaseStateProvinces = mapValues(
  StateProvinces,
  method('toUpperCase'),
);
const PROVINCE_MAP = invert(UppercaseStateProvinces);

const getProvinceAbbreviation = (province: string) => {
  const provinceKey = province?.toUpperCase() as keyof typeof StateProvinces;
  if (StateProvinces[provinceKey]) return provinceKey;
  return PROVINCE_MAP[provinceKey] || province;
};

export default getProvinceAbbreviation;
